import { arrayOf } from 'prop-types';
import actionType from './action';

export default {
  actions: arrayOf(actionType)
};
